// src/pages/admin/Education/ViewStudent.jsx
import React from 'react';
import {
  FaUser,
  FaEnvelope,
  FaPhone,
  FaCalendarAlt,
  FaMapMarkerAlt,
  FaGraduationCap,
  FaBuilding,
  FaMoneyBillWave,
  FaCheckCircle,
  FaClock,
  FaIdCard,
  FaFileAlt,
} from 'react-icons/fa';

function ViewStudent({ data }) {
  if (!data) {
    return <div className="text-center py-4">No data available</div>;
  }

  const formatDate = (date) => {
    if (!date) return 'N/A';
    return new Date(date).toLocaleString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  const getStatusBadge = (status) => {
    const statusMap = {
      'pending': { class: 'badge bg-warning', label: 'Pending' },
      'approved': { class: 'badge bg-success', label: 'Approved' },
      'rejected': { class: 'badge bg-danger', label: 'Rejected' },
    };
    const statusInfo = statusMap[status] || statusMap['pending'];
    return <span className={statusInfo.class}>{statusInfo.label}</span>;
  };

  const getGenderLabel = (gender) => {
    const genderMap = {
      'male': 'Male',
      'female': 'Female',
      'other': 'Other',
    };
    return genderMap[gender] || 'N/A';
  };

  const displayFields = [
    { key: 'full_name', label: 'Full Name', icon: <FaUser /> },
    { key: 'father_name', label: 'Father Name', icon: <FaUser /> },
    { key: 'mother_name', label: 'Mother Name', icon: <FaUser /> },
    { key: 'date_of_birth', label: 'Date of Birth', format: formatDate, icon: <FaCalendarAlt /> },
    { key: 'gender', label: 'Gender', format: getGenderLabel, icon: <FaUser /> },
    { key: 'email', label: 'Email', icon: <FaEnvelope /> },
    { key: 'phone', label: 'Phone', icon: <FaPhone /> },
    { key: 'whatsapp', label: 'WhatsApp', icon: <FaPhone /> },
    { key: 'address', label: 'Address', icon: <FaMapMarkerAlt /> },
    { key: 'city', label: 'City', icon: <FaMapMarkerAlt /> },
    { key: 'state', label: 'State', icon: <FaMapMarkerAlt /> },
    { key: 'pincode', label: 'Pincode', icon: <FaMapMarkerAlt /> },
    { key: 'education_level', label: 'Education Level', icon: <FaGraduationCap /> },
    { key: 'course', label: 'Course', icon: <FaGraduationCap /> },
    { key: 'college_name', label: 'College/Institution', icon: <FaBuilding /> },
    { key: 'college_address', label: 'College Address', icon: <FaMapMarkerAlt /> },
    { key: 'year_of_study', label: 'Year of Study', icon: <FaCalendarAlt /> },
    { key: 'percentage_marks', label: 'Percentage/GPA', icon: <FaFileAlt /> },
    { key: 'scholarship_type', label: 'Scholarship Type', icon: <FaMoneyBillWave /> },
    { key: 'scholarship_amount', label: 'Scholarship Amount', icon: <FaMoneyBillWave /> },
    { key: 'application_reason', label: 'Reason for Application', icon: <FaFileAlt /> },
    { key: 'status', label: 'Status', format: getStatusBadge },
    { key: 'remarks', label: 'Admin Remarks', icon: <FaFileAlt /> },
    { key: 'created_at', label: 'Registered At', format: formatDate, icon: <FaClock /> },
  ];

  const getValue = (field) => {
    let value = data[field.key];
    if (field.format) {
      value = field.format(value);
    }
    return value || 'N/A';
  };

  return (
    <div className="view-student-container">
      {/* User ID Badge */}
      {data.user_id && (
        <div className="text-center mb-3">
          <span className="badge bg-info">
            <FaIdCard className="me-1" /> User ID: {data.user_id}
          </span>
        </div>
      )}

      <div className="table-responsive">
        <table className="table table-bordered table-striped">
          <tbody>
            {displayFields.map((field) => (
              <tr key={field.key}>
                <th style={{ width: '30%', backgroundColor: '#f8f9fa' }}>
                  {field.icon && <span className="me-2">{field.icon}</span>}
                  {field.label}
                </th>
                <td>
                  {field.key === 'application_reason' || field.key === 'remarks' ? (
                    <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                      {getValue(field)}
                    </div>
                  ) : (
                    getValue(field)
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ViewStudent;